import {usePlantConfig} from '@domain/shifthandover'
import {UseMutationResult} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {CreateDalogMaintenanceNotificationActionDto, DalogActionDto} from '../../types'

import {DalogCreateMaintenanceNotificationDialogContent} from './DalogCreateMaintenanceNotificationDialogContent'

type DalogCreateMaintenanceNotificationDialogProps = {
  event: DalogActionDto
  plantId: string
  showDialog: boolean
  setDialog: (state: boolean) => void
  createNotification: UseMutationResult<
    string,
    AxiosError,
    CreateDalogMaintenanceNotificationActionDto
  >
}

export const DalogCreateMaintenanceNotificationDialog: React.FC<
  DalogCreateMaintenanceNotificationDialogProps
> = ({event, plantId, setDialog, createNotification: createNotificationProp}) => {
  const createNotification = (notification: CreateDalogMaintenanceNotificationActionDto) => {
    createNotificationProp.mutate({
      ...notification
    })
    setDialog(false)
  }

  const {i18n} = useTranslation(FEATURE_NAMESPACE)
  const {data} = usePlantConfig({plantId, language: i18n.language})

  if (!data) {
    return null
  }

  return (
    <DalogCreateMaintenanceNotificationDialogContent
      onClose={() => {
        setDialog(false)
      }}
      plantId={data.plantId}
      workCenters={data.workCenters}
      open={true}
      onConfirm={createNotification}
      event={event}
    />
  )
}
